export default __webpack_public_path__ + "static/media/clouds-night.dde30954.svg";